import React from 'react';
import styled, { withTheme } from "styled-components";
import { createSvgImageUrl } from '../icon-utils';
const IconWrapper = styled.div `
  display: block;
  height: ${(props) => props.size + 5}px;
  width: ${(props) => props.size + 5}px;
`;
const Icon = styled.img `
  display: block;
  padding: 0;
  margin: 0;
  height: ${(props) => props.size}px;
  width: ${(props) => props.size}px;
  border-radius: 50%;
  background-size:  cover;
  background-repeat:  no-repeat;
  background-position: center center;  
`;
const createLiveChatIconUrl = (color) => {
    const icon = `<svg width="42px" height="42px" viewBox="0 0 42 42" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <title>Group 4 Copy</title>
        <defs>
            <circle id="path-1" cx="21" cy="21" r="21"></circle>
        </defs>
        <g id="Updated-Design" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Whitespace-messages" transform="translate(-511.000000, -608.000000)">
                <g id="Group-4-Copy" transform="translate(511.000000, 608.000000)">
                    <g id="sydney">
                        <mask id="mask-2" fill="white">
                            <use xlink:href="#path-1"></use>
                        </mask>
                        <use id="Mask" fill="${color}" xlink:href="#path-1"></use>
                    </g>
                    <g id="Icons/Font-Awesome/Line-Copy-2" transform="translate(7.165904, 8.000000)" stroke="#FFFFFF">
                        <path d="M10.0282461,28.5394203 L17.0217391,23.2929062 L25.0846682,23.2929062 C27.0611947,23.2929062 28.6681922,21.6859087 28.6681922,19.7093822 L28.6681922,3.58352403 C28.6681922,1.60699749 27.0611947,-1.13686838e-13 25.0846682,-1.13686838e-13 L3.58352403,-1.13686838e-13 C1.60699749,-1.13686838e-13 4.26325641e-14,1.60699749 4.26325641e-14,3.58352403 L4.26325641e-14,19.7093822 C4.26325641e-14,21.6859087 1.60699749,23.2929062 3.58352403,23.2929062 L8.95881007,23.2929062 L8.95881007,27.9962815 C8.95881007,28.5449976 9.58593771,28.8641662 10.0282461,28.5394203 Z" id="Icon-Color"></path>
                    </g>
                    <path d="M16.4951172,23 L16.4951172,21.9990234 L13.4726562,21.9990234 L13.4726562,15.8613281 L12.3056641,15.8613281 L12.3056641,23 L16.4951172,23 Z M18.8925781,23 L18.8925781,15.8613281 L17.7255859,15.8613281 L17.7255859,23 L18.8925781,23 Z M23.5556641,23 L26.0556641,15.8613281 L24.8447266,15.8613281 L23.3554688,20.2802734 C23.3001302,20.4365234 23.2285156,20.6774089 23.140625,21.0029297 C23.0527344,21.3284505 22.9876302,21.6149089 22.9453125,21.8623047 C22.9192708,21.6995443 22.8623047,21.4513346 22.7744141,21.1176758 C22.6865234,20.7840169 22.6035156,20.5113932 22.5253906,20.2998047 L22.5253906,20.2998047 L21.0361328,15.8613281 L19.8349609,15.8613281 L22.3251953,23 L23.5556641,23 Z M31.0361328,23 L31.0361328,22.0087891 L28.1650391,22.0087891 L28.1650391,19.7675781 L30.8554688,19.7675781 L30.8554688,18.7910156 L28.1650391,18.7910156 L28.1650391,16.8476562 L31.0361328,16.8476562 L31.0361328,15.8613281 L26.9980469,15.8613281 L26.9980469,23 L31.0361328,23 Z" id="LIVE" fill="#FFFFFF" fill-rule="nonzero"></path>
                </g>
            </g>
        </g>
    </svg>`;
    return createSvgImageUrl(icon);
};
const LiveChatIcon = (props) => {
    var _a;
    const iconColor = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.button.background;
    return (React.createElement(IconWrapper, { size: props.size },
        React.createElement(Icon, { size: props.size, src: createLiveChatIconUrl(iconColor), alt: props.alt, "aria-labelledby": props.alt })));
};
export default withTheme(LiveChatIcon);
